import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { IConfigData } from '../../submodules/silverlight-common/lib/ts/src/interface/config.data.interface';
import UIConstants from '../../app-constants/ui-constants';
import APIURLConstants from '../../app-constants/api-url-constants';
@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly configConstants = APIURLConstants.Config_Service;
  private readonly URL = this.configConstants.BASE_URL;

  // Accessible variable to hold the latest configuration data
  private configDataSubject = new BehaviorSubject<IConfigData[] | null>(null);
  public configData$ = this.configDataSubject.asObservable();

  constructor(public http: HttpClient) {}

  /**
   * Get the configuration data from the server and update the configDataSubject
   */
  getConfigData(): Observable<{responseData:IConfigData[]}> {
    return this.http.get<{responseData:IConfigData[]}>(this.URL).pipe(
      tap((data) => {
        // Update the BehaviorSubject with the latest data
        this.configDataSubject.next(data.responseData);
      })
    );
  }
  updateProductTypes(productArray: string[]): Observable<any> {
    const productTypeObject = {
      keyName: 'InjectorTypes',
      keyValue: productArray.join(', '),
    };
    return this.http.put<any>(
      this.configConstants.UPDATE_PRODUCT_TYPES,
      productTypeObject
    );
  }
}
